import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4.786 9.273h2.289q.68 0 1.012.059.336.055.597.234.266.18.442.48.176.298.176.669 0 .402-.22.738a1.33 1.33 0 0 1-.585.504q.523.153.805.52.28.366.28.863a1.7 1.7 0 0 1-.183.762q-.18.366-.496.59a1.64 1.64 0 0 1-.773.269q-.29.03-1.395.039h-1.95zm1.156.954v1.324H6.7q.675 0 .84-.02a.76.76 0 0 0 .465-.203.6.6 0 0 0 .172-.45q0-.265-.149-.429-.144-.168-.433-.203-.172-.02-.989-.02zm0 2.277v1.531h1.07q.626 0 .793-.035a.7.7 0 0 0 .418-.227.7.7 0 0 0 .165-.488.75.75 0 0 0-.125-.437.7.7 0 0 0-.364-.262q-.234-.082-1.023-.082zM11.532 15v-4.758H9.833v-.969h4.55v.97H12.69V15zm3.294 0V9.273h1.125l2.343 3.825V9.273h1.075V15h-1.16l-2.31-3.734V15z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }